import { getFormatDate, } from '@/public/utils'
import _, { set, get } from "lodash"
import moment from 'moment'

export const getFormatDateIsNull = (date, format) => {
    return date ? getFormatDate(moment(date), '-', format || 'YYYY-MM-DD') : "-"
}

export const updateBills = (data, record, updateFun, value) => {
    var cloneData = _.cloneDeep(data)
    cloneData.forEach(item => { set(item, 'match_invoice_amount', get(item, 'invoice_id') == get(record, 'invoice_id') ? value : get(item, 'match_invoice_amount')) })
    updateFun(cloneData)
}

export const sameChange = (olds, news, key) => {
    return olds.map(old => {
        if (_.findIndex(news, [key, get(old, key)]) != -1) {
            return _.find(news, [key, get(old, key)])
        } else {
            return old
        }
    })
}

export const filterSigoCompanyCol = (purchases, columns,params) => {
    var cloneData = _.cloneDeep(columns)
    if (get(purchases,'length') <=1 ) {
        cloneData = _.differenceBy(cloneData, [{ title: "结算主体" }], 'title')
    }
    if(get(params,'query.status_list.length')){
        cloneData = _.differenceBy(cloneData, [{ title: "发票状态" }], 'title')
    }
    return cloneData
}

export const transferx0ToX0 = (map) => {
    _.keys(map).map(key=>{
        var newVals = get(map,key)
        if(_.keys(newVals).includes('x0')){
            set(newVals,'X0',get(newVals,'x0'))
            delete  newVals['x0']
        }
        set(map,key,newVals)
    })
    return map
}

export const toggleFullScreen = () => {
    let isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
    if (isFullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    } else {
        let element = document.getElementById("scsContent")
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  }


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/common/utils.js